// Notifications SMS — couche prête pour un fournisseur tunisien (Orange SMS API,
// TunisieSMS…). Tant que les identifiants ne sont pas renseignés, l'envoi
// automatique est désactivé et l'on retombe sur un partage manuel (SMS/WhatsApp).
const KEY = 'oliva.sms';

export const SMS_DEFAUT = {
  actif: false,
  fournisseur: 'Orange SMS API',
  url: '',
  token: '',
  expediteur: '',
  gabarit:
    'Huilerie Hassan Ellouze : votre lot {lot} ({poids} Kg) est enregistré. Suivez-le en direct : {lien}',
};

export const getSmsConfig = () => {
  const raw = localStorage.getItem(KEY);
  return raw ? { ...SMS_DEFAUT, ...JSON.parse(raw) } : SMS_DEFAUT;
};

export const setSmsConfig = (patch) => {
  const next = { ...getSmsConfig(), ...patch };
  localStorage.setItem(KEY, JSON.stringify(next));
  return next;
};

export const construireMessage = ({ lot, poids, lien, nom }) =>
  getSmsConfig()
    .gabarit.replace('{lot}', lot ?? '')
    .replace('{poids}', poids ?? '')
    .replace('{lien}', lien ?? '')
    .replace('{nom}', nom ?? '');

export const lienWhatsapp = (tel, message) =>
  `https://wa.me/${String(tel || '').replace(/[^\d]/g, '')}?text=${encodeURIComponent(message)}`;

export const lienSms = (tel, message) =>
  `sms:${String(tel || '').replace(/\s/g, '')}?&body=${encodeURIComponent(message)}`;

// Envoi automatique via le fournisseur configuré (proxy backend).
export async function envoyerSms({ destinataire, message }) {
  const cfg = getSmsConfig();
  if (!cfg.actif || !cfg.url || !cfg.token)
    return { error: 'Fournisseur SMS non configuré — utilisez le partage manuel (SMS / WhatsApp).' };

  try {
    const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/sms/envoyer`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        url: cfg.url,
        token: cfg.token,
        expediteur: cfg.expediteur,
        destinataire,
        message,
      }),
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) return { error: data.detail ?? 'Échec de l’envoi SMS.' };
    return { error: null, data };
  } catch {
    return { error: 'Passerelle SMS injoignable — utilisez le partage manuel.' };
  }
}
